import {
  Button,
  Flex,
  Heading,
  Image,
  Link,
  Stack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';
import { GrDocumentDownload } from 'react-icons/gr';
import ResumePDF from '../assets/fw20_0299_Sanjaykumar_Rathva_Resume.pdf';

export default function HeroCardOne() {
  const onClickDownloadHandler = () => {
    fetch(ResumePDF)
      .then(response => {
        response
          .blob()
          .then(blob => {
            const fileURL = window.URL.createObjectURL(blob);
            const aLink = document.createElement('a');
            aLink.href = fileURL;
            aLink.download = 'fw20_0299-Sanjaykumar-Rathva-Resume.pdf';
            aLink.click();
          })
          .catch(error => console.error(error.message));
      })
      .catch(error => console.error(error.message));
  };

  return (
    <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
      <Flex p={8} flex={1} align={'center'} justify={'center'}>
        <Stack spacing={6} w={'full'} maxW={'lg'}>
          <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
            <Text
              as={'span'}
              position={'relative'}
              _after={{
                content: "''",
                width: 'full',
                height: useBreakpointValue({ base: '20%', md: '30%' }),
                position: 'absolute',
                bottom: 1,
                left: 0,
                bg: 'blue.400',
                zIndex: -1,
              }}
            >
              Hi! I am Sanjay Rathva
            </Text>
            <br />{' '}
            <Text color={'blue.400'} as={'span'}>
              Full Stack Web Developer
            </Text>{' '}
          </Heading>
          <Text fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
            Hi! I am Sanjaykumar Rathva. I am MERN stack web developer based in
            Vadodara, Gujarat. Thank you for visiting me.
          </Text>
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
            <Link href="/#contact">
              <Button
                px={'2rem'}
                rounded={'full'}
                bg={'blue.400'}
                color={'white'}
                _hover={{
                  bg: 'blue.500',
                }}
              >
                Contact Me
              </Button>
            </Link>

            <Link
              href="https://drive.google.com/file/d/1KlIfU0jYy0wS1mJ9X3RSXb_JZdrrsO_l/view?usp=share_link"
              isExternal={true}
            >
              <Button
                px={'2rem'}
                rounded={'full'}
                onClick={onClickDownloadHandler}
              >
                <Text px={'3'}>Resume</Text>{' '}
                <GrDocumentDownload size={20} color={'#4299e1'} />
              </Button>
            </Link>
          </Stack>
        </Stack>
      </Flex>
      <Flex flex={1}>
        <Image
          alt={'Login Image'}
          objectFit={'cover'}
          src={
            'https://images.unsplash.com/photo-1527689368864-3a821dbccc34?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
          }
        />
      </Flex>
    </Stack>
  );
}
